module.exports = __webpack_public_path__ + "static/media/speaker3.38aacc20.png";